<mat-chip-list aria-label="tags">
  <mat-chip class="ellipsis" *ngFor="let tag of tags" [routerLink]="TagsRoute.getDetailsPath(tag.id)">
    {{ tag.title }}
  </mat-chip>
</mat-chip-list>
